<div class="CountryUpdate-mobile">
    <!-- SELECT -->
    <div class="SelectContainer">
        <mat-form-field appearance="fill" class="FormElement">
            <mat-label>Filter by</mat-label>
            <mat-select [(value)]="selected">
                <mat-option value="country">Country</mat-option>
                <mat-option [value]="pillar" *ngFor="let pillar of tocCountryBased.pillarValues;" [value]="">
                    {{('uishared.pillars.' + pillar) | transloco}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!-- BY COUNTRY -->
    <ng-container *ngIf="selected === 'country'">
        <mat-accordion *ngFor="let country of tocCountryBased.countryValues; let c = index;" class="Accordion-country">
            <mat-expansion-panel [expanded]="true" data-cy="byDateDocumentsMobile">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{('uishared.CountryNames.' + country) | transloco}}</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="Content-country">
                    <ul>
                        <li *ngFor="let pillar of tocCountryBased.pillarValues; let p = index;">
                            <h4 *ngIf="getCellContent(tocCountryBased.countryValues.length, p, c).size != 0">{{('uishared.pillars.' + pillar) | transloco}}</h4>
                            <div *ngFor="let cellItem of getCellContent(tocCountryBased.countryValues.length, p, c) | keyvalue">
                                <a *ngIf="cellItem.key.length != 14" [routerLink]="'../' + [tocCountryBased.uniqueNumber + '_' + cellItem.key]">
                                    {{cellItem.value}}
                                </a>
                                <a *ngIf="cellItem.key.length === 14" [routerLink]="'../' + [cellItem.key]">
                                    {{cellItem.value}}
                                </a>
                            </div>
                        </li>
                    </ul>
                    <div class="ViewAll">
                        <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + getCountryUuids(tocCountryBased.countryValues.length, tocCountryBased.pillarValues.length, c) ]">
                            View {{('uishared.CountryNames.' + country) | transloco}} report
                        </a>
                    </div>  
                </div>  
            </mat-expansion-panel>
        </mat-accordion>
    </ng-container>
    <!-- BY PILLARS -->
    <div *ngFor="let pillar of tocCountryBased.pillarValues; let p = index;">
        <ng-container *ngIf="selected === pillar">
            <mat-accordion class="Accordion-country">
                <mat-expansion-panel [expanded]="true" data-cy="byDateDocumentsMobile">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <!-- {{('uishared.pillars.' + pillar) | transloco}} -->
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="Content-pilar">
                        <ul>
                            <li *ngFor="let country of tocCountryBased.countryValues; let c = index;">
                                <h4 *ngIf="getCellContent(tocCountryBased.countryValues.length, p, c).size != 0">{{('uishared.CountryNames.' + country) | transloco}}</h4>
                                <div *ngFor="let cellItem of getCellContent(tocCountryBased.countryValues.length, p, c) | keyvalue">
                                    <a *ngIf="cellItem.key.length != 14" [routerLink]="'../' + [tocCountryBased.uniqueNumber + '_' + cellItem.key]">
                                        {{cellItem.value}}
                                    </a>
                                    <a *ngIf="cellItem.key.length === 14" [routerLink]="'../' + [cellItem.key]">
                                        {{cellItem.value}}
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <div class="ViewAll">
                            <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + getPillarUuids(tocCountryBased.countryValues.length, p) ]">
                                View {{('uishared.pillars.' + pillar) | transloco}} report
                            </a>
                        </div>     
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </ng-container>
    </div>
    <!-- DISPLAY BUTTON -->
    <div class="DisplayButton">
        <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + getAllUuids() ]">View full report</a>
    </div>
</div>